import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { v4 as uuidv4 } from 'uuid';

export interface IColaboradorSeguimiento {
  colseg_id: number | string;
  colseg_colid: number | string;
  colseg_mails: string | null;
  colseg_modificado_colid?: number | string | null;
  colseg_eliminado_colid?: number | string | null;
  colseg_activo: string;
}

export interface ResponseInset<T> {
  statusCode:   number;
  statusMsg:    string;
  statusDetail: string;
  debugInfo:    null;
  httpCode:     null;
  attributes:   null;
  data:         T;
  segment:      null;
}

export class ColaboradorSeguimientoSystem {
  private readonly base = '/colaborador-seguimiento';

  constructor(private requestHandler: XhrRequestHandler) {}

  // Obtener un seguimiento por ID
  async getById(colsegId: string) {
    const headers = { idtransaccion: uuidv4(), msgtransaccion: "Obtener seguimiento por ID" };
    return await this.requestHandler.getheader<ResponseInset<IColaboradorSeguimiento>>(
      `${this.base}/find-by-id/${colsegId}`,
      headers
    );
  }

  // Obtener un seguimiento por ID de colaborador
  async getByColaborador(colId: string) {
    const headers = { idtransaccion: uuidv4(), msgtransaccion: "Obtener seguimiento por colaborador" };
    return await this.requestHandler.getheader<ResponseInset<IColaboradorSeguimiento>>(
      `${this.base}/find-by-colaborador/${colId}`,
      headers
    );
  }

  // Upsert (insertar o actualizar)
  async upsert(data: Pick<IColaboradorSeguimiento, 'colseg_colid' | 'colseg_mails'>) {
    const headers = { idtransaccion: uuidv4(), msgtransaccion: "Upsert colaborador seguimiento" };
    return await this.requestHandler.postss<ResponseInset<{ colseg_id: string, colseg_mails: string }>>(
      `${this.base}/upsert`,
      data,
      headers
    );
  }

  // Eliminado lógico
  async softDelete(colsegId: number) {
    return await this.requestHandler.delete<boolean>(`${this.base}/delete/${colsegId}`);
  }
}
